import { HeroAttributesUI } from "./HeroAttributesUI";
import { StandardProps } from "../componentMap";

export function HeroAttributes({ product }: Pick<StandardProps, "product">) {
  return <HeroAttributesUI title={product.title} />;
}
